import Vue from 'vue';
import navigation from './navigation/index.vue';
import foot from "./foot/index.vue";
//模块：组件初始挂载
export default Vue.extend({
    components: {
        navigation: navigation,
        foot: foot
    },
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {
        toLogin: function () {
            this.$router.push('/product');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/index.vue
// module id = null
// module chunks = 